import { Injectable } from '@angular/core';
import { MainService } from "./main.service";
import { HttpClient } from '@angular/common/http';
import { ToastService } from '../toast.service';
import { StorageService } from '../storage.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class FilesService extends MainService {

	constructor(
		public http: HttpClient,
		public toastService: ToastService,
		public storage: StorageService,
		public router: Router,
	) {
		super(http, toastService, storage, router);
	}

	getFileExtension(filename:string){
		let fName = filename.split('.');
		return fName[fName.length - 1];
	}

	setFileExt(item){
		let ext = this.getFileExtension(item.name);
		ext = ext.toLowerCase();
		item['ext'] = ext;
	}

	/**
	 * Format bytes as human-readable text.
	 * 
	 * @param bytes Number of bytes.
	 * @param si True to use metric (SI) units, aka powers of 1000. False to use 
	 *           binary (IEC), aka powers of 1024.
	 * @param dp Number of decimal places to display.
	 * 
	 * @return Formatted string.
	 */
	humanFileSize(size, hasUnit=true) {
		var i = size == 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
		var s = +((size / Math.pow(1024, i)).toFixed(2)) * 1 + '';
		if(hasUnit){
			s += ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
		}
		return s;

		// const thresh = si ? 1000 : 1024;
	
		// if (Math.abs(bytes) < thresh) {
		// return bytes + ' B';
		// }
	
		// const units = si 
		// ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] 
		// : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
		// let u = -1;
		// const r = 10**dp;
	
		// do {
		// 	bytes /= thresh;
		// 	++u;
		// } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);
	
		// if(hasUnit){
		// 	return bytes.toFixed(dp) + ' ' + units[u];
		// }
		// else {
		// 	return bytes.toFixed(dp);
		// }
	}
}

export class ImageLazyLoad {

	init(htmlClass:string, loadingHtmlClass:string, loadedHtmlClass:string, callback:any=null){
		let images:any = document.getElementsByClassName(htmlClass);
		Array.prototype.forEach.call(images, image => {

			image.classList.remove(loadedHtmlClass);
			image.classList.add(loadingHtmlClass);

			try {
				let curImg = new Image();
				curImg.src = image.dataset.imgsrc;
				curImg.onload = function(){
					image.src = image.dataset.imgsrc;

					image.classList.remove(loadingHtmlClass);
					image.classList.add(loadedHtmlClass);

					if(typeof callback == 'function'){
						callback();
					}
				}
			} catch (error) {
			}
		});
	}
}

export class UseUploadedFiles {
	uploadedFilesInit:any = (a) => {
		return {
			filters: {
				page: 1,
				page_size: 10,
				name: ''
			},
			files: null,
			quickViewImage: '',

			selectedItem: {
				id: null
			},

			selectedItems: {},
			_selectedItems: [],
			maxLayout: 10,
			canSelectectMultiLayout: false,

			isAddingToCart: false,

			reset(isIncludeSelectedItems = true){
				this.files = null;
				this.quickViewImage = '';
				this.selectedItem = {
					id: null
				}
				if(isIncludeSelectedItems){
					this.selectedItems = [];
				}
				
				
			},

			setMultiLayout() {
				let additionalLayoutOption = a.product.options.find(i => ("additional layout" == i.title));
				if(additionalLayoutOption){
					this.maxLayout = additionalLayoutOption.values.length;

					/** 
					 * canSelectectMultiLayout should always be false because
					 * as requested by Jessica from call last Mar 17 2026
					 * upload should only be 1 by 1
					 */
					this.canSelectectMultiLayout = (a.selectedQty == 10);
				}
				return this;
			},
			

			goToPage(page:any=null){
				if(page){
					this.filters.page = parseInt(page);
				}
				this.getUploadedFiles();
			},

			getUploadedFiles(){
				this.reset(false);

				let url = a.filesService.getStoreUrl('/V1/lns-orderattachment/files?');
		
				let urlQry = [];
				if(this.filters.page){
					urlQry.push('page='+this.filters.page);
				}
				if(this.filters.page_size){
					urlQry.push('page_size='+this.filters.page_size);
				}
				if(this.filters.name){
					urlQry.push('name='+this.filters.name);
				}
				url += urlQry.join('&');
		
				this.files = null;
				a.filesService.doRequest(url, null, 'GET').then((data:any) => {
					if(!data.error && data.result){
						data.result.items.forEach(item => {
							this.setInitItem(item);
						});
						data.result['pages'] = [];
						
						let i: any = 0;
						for (i = 1; i <= data.result.last_page_number; i++) {
							data.result.pages.push(i);
						}

						this.files = data.result;

						setTimeout(() => {
							let imageLazyLoad:ImageLazyLoad = new ImageLazyLoad();
							imageLazyLoad.init('layout-img-file', 'layout-img-file-loading', 'layout-img-file-loaded', () => {
								
							});
						}, 50);
					}
				});
			},

			setInitItem(item){
				item['is_editing'] = false;
				item['is_saving'] = false;
				item['is_view_actual_image'] = false;
		
				item.order_ids = item.order_ids.split(',');
				item.order_increment_ids = item.order_increment_ids.split(',');
				item.order_item_ids = item.order_item_ids.split(',');
		
				item['initial_data'] = JSON.parse(JSON.stringify(item));
				if(typeof item.metadata == 'string'){
					item.metadata = JSON.parse(item.metadata);
				}
				a.filesService.setFileExt(item);
			},

			openQuickViewArtWorkModal(item, showOnly=false){
				item.is_view_actual_image = true;
				this.quickViewImage = "https://firebase.entrelabel.com/download.php?file=" + item.full_path;
		
				let elContainer = document.getElementById('quick-view-artwork-container');
				
				if(!showOnly){
					let el = document.getElementById('qva-image');
					el.setAttribute("data-imgsrc", this.quickViewImage);

					a.filesService.setLoader(true);

					let imageLazyLoad:ImageLazyLoad = new ImageLazyLoad();
					imageLazyLoad.init('lazy-load', 'lazy-loading', 'lazy-loaded', () => {
						a.filesService.setLoader(false);
						elContainer.classList.remove('d-none');
					});
				}
		
		
			},

			closeQuickViewArtWorkModal(){
				this.quickViewImage = '';
		
				let elContainer = document.getElementById('quick-view-artwork-container');
				elContainer.classList.add('d-none');
		
				let el = document.getElementById('qva-image');
				el.removeAttribute("data-imgsrc");
				el.setAttribute("src", '');
			},
		
			isImage(item){
				if (item.ext == 'jpg' || item.ext == 'jpeg' || item.ext == 'png') {
					return true;
				}
				else {
					return false;
				}
			},
		
			addUploadFile(item){
				if(this.canSelectectMultiLayout){
					let totalFiles = this._selectedItems.length + a.files.length;
					if(totalFiles < this.maxLayout){
						if(typeof this.selectedItems["_" + item.id] != 'undefined'){
							delete this.selectedItems["_" + item.id];
						}
						else {
							this.selectedItems["_" + item.id] = item;
						}
						setTimeout(() => {
							this._selectedItems = Object.values(this.selectedItems);
						}, 10);
					}
				}
				else {
					this.selectedItem = item;
				}

				this.openQuickViewArtWorkModal(item, true);
			},

			startAddToCartV2(){
				this.isAddingToCart = true;
				a.startAddToCartV2();
			},

			inSelectedItems(itemId){
				return typeof this.selectedItems['_' + itemId] != 'undefined';
			}
		}
	};
}
